module.controller('date', function(xmppAuth, $scope, $mdDialog, $filter, $window, $mdToast, theme, cryptool) {

  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp');

  $scope.date = JSON.parse($window.localStorage.getItem("metadataObj"));
  $scope.theme = theme.getTheme();
  $scope.isOpen = false;
  $scope.current_day= new Date();
 
  if($scope.date.constraints.minDate)
    $scope.minDate = new Date($scope.date.constraints.minDate);

  if($scope.date.constraints.maxDate)
    $scope.maxDate = new Date($scope.date.constraints.maxDate);

  $scope.defaultDate = function() {
      var today = new Date();
      $scope.maxDate = new Date($scope.date.constraints.maxDate);
      if($scope.maxDate && $scope.maxDate < today)
        $scope.current_day = $scope.maxDate;
  }

  $scope.closeDialog = function(){
    $mdDialog.cancel();
  };

  $scope.msgToast = function(message, type){
    $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(2000)
    );
  };

this.sendMsgDate = function(validForm) {
  if(validForm == true){
    var date = document.querySelectorAll("#datePicker input")[0].value;
    var format = "dd/MM/yyyy";

    var dateMomentObject = moment(date, "DD/MM/YYYY");
    var dateObject = dateMomentObject.toDate();
    var dateFormat = $filter('date')(new Date(dateObject), format);
    var dateLong = dateObject.getTime();
    var dateString = dateLong.toString();
    var meta = JSON.parse($window.sessionStorage.getItem("confirmDialog"));
      if(meta && meta.confirmation) {         
          $scope.pendingMessage = dateFormat;
          $mdDialog.cancel();
          $scope.showConfirmation(); 
          $scope.pendingSend = function() {
            xmppAuth.Chat.sendMessageDate(xmppUser+"@"+xmpp_domain, dateFormat, dateString, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);              
            $scope.metadataObj = undefined;
          }               
      } else {
        xmppAuth.Chat.sendMessageDate(xmppUser+"@"+xmpp_domain, dateFormat, dateString, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
        $mdDialog.cancel();
        $scope.metadataObj = undefined;
      }              
    }
  };

  $scope.pendingSend = function(){};
  $scope.showConfirmation = function(ev) {   
    var confirmDialog =  JSON.parse($window.sessionStorage.getItem("confirmDialog")); 
    confirmDialog.response = $scope.pendingMessage;
    $window.sessionStorage.setItem("confirmDialog", JSON.stringify(confirmDialog));       

    $mdDialog.show({
        controller: 'confirmationCntrl',
        templateUrl: './views/dashboard/confirmation.html',
        parent: angular.element(document.body),
        targetEvent: ev
    }).then(function(answer) {
            $scope.pendingSend();
      }, function() {
          
    });
  };

  this.disabledDays = function(date){
    $scope.message_filtered = $scope.date.constraints.disabledWeekDaysMessage || "Fecha seleccionada no permitida";
    var day = date.getDay();
    var data = day;

    if($scope.date.constraints.disabledWeekDays){
      var disabled =  $scope.date.constraints.disabledWeekDays.find(element => element === day);
      if(disabled !== undefined)
        data = [(day !== disabled)][0];
    }
    if($scope.date.constraints.disabledDates){
      var dateRangeToDisable = [];
      $scope.date.constraints.disabledDates.forEach(function(item, data) {
        dateRangeToDisable.push(new Date(item));
      });
  
      angular.forEach(dateRangeToDisable, function(item) {
        if (formatDate(item) === formatDate(date)) {
          data = false;
        }
      });
    }

    return day === data;
  };
 
  function formatDate(d) {
    const format = $scope.theme.getDateFormat() || 'dd/MM/yyyy';
    var date = new Date(d); 
    if (isNaN(date.getTime())) {
        throw new Error('El primer parámetro debe ser una fecha válida.');
    }
    const pad = (num) => num.toString().padStart(2, '0');
    
    const replacements = {
        'yyyy': date.getFullYear(),
        'yy': date.getFullYear().toString().slice(-2),
        'MM': pad(date.getMonth() + 1),
        'M': date.getMonth() + 1,
        'dd': pad(date.getDate()),
        'd': date.getDate(),
        'HH': pad(date.getHours()),
        'H': date.getHours(),
        'hh': pad(date.getHours() % 12 || 12),
        'h': date.getHours() % 12 || 12,
        'mm': pad(date.getMinutes()),
        'm': date.getMinutes(),
        'ss': pad(date.getSeconds()),
        's': date.getSeconds(),
        'a': date.getHours() < 12 ? 'am' : 'pm',
        'A': date.getHours() < 12 ? 'AM' : 'PM'
    };

    return format.replace(/yyyy|yy|MM|M|dd|d|HH|H|hh|h|mm|m|ss|s|a|A/g, match => replacements[match]);
}

  this.disableListDays = function(date) {
    var showDate = true;
    var dateRangeToDisable = [];
    $scope.date.constraints.disabledDates.forEach(function(item, data) {
      dateRangeToDisable.push(new Date(item));
    });
    angular.forEach(dateRangeToDisable, function(item) {
      if (formatDate(item) === formatDate(date)) {
        showDate = false;
      }
    });
    return showDate;
  };
}).config(function($mdDateLocaleProvider) {
  // Example of a Spanish localization.
  $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                                  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
                                  'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
  $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
  $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
  $mdDateLocaleProvider.firstDayOfWeek = 1;
  // Optional.
  $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
    return 'Semana ' + weekNumber;
  };

  $mdDateLocaleProvider.formatDate = function(date) {
    return moment(date).format('DD/MM/YYYY');
  };

  $mdDateLocaleProvider.parseDate = function(dateString) {
    var m = moment(dateString, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : new Date(NaN);
  };
  $mdDateLocaleProvider.msgCalendar = 'Calendario';
  $mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendario';
});
